// extracted by mini-css-extract-plugin
export var body = "BoxNavigation-module--body--IUF3D";
export var component = "BoxNavigation-module--component--4fFyu";
export var header = "BoxNavigation-module--header--iInRT";
export var item = "BoxNavigation-module--item--Mn0Sd";
export var link = "BoxNavigation-module--link--h9ZUC";
export var list = "BoxNavigation-module--list--pi6gY";
export var preamble = "BoxNavigation-module--preamble--XHp48";
export var title = "BoxNavigation-module--title--icShD";